// frontend/src/pages/admin/AgreementForm.jsx
import { useState } from 'react';
import { createAgreement, updateAgreement } from '../../lib/api';
import { C, inp, lbl, Btn, Card, ErrBox } from '../../components/UI';

export default function AgreementForm({ existing, onDone, showToast }) {
  const [form, setForm] = useState({
    title:         existing?.title          || '',
    customerName:  existing?.customer_name  || '',
    customerEmail: existing?.customer_email || '',
    content:       existing?.content        || '',
  });
  const [errors,  setErrors]  = useState({});
  const [apiErr,  setApiErr]  = useState('');
  const [loading, setLoading] = useState(false);

  function validate() {
    const e = {};
    if (!form.title.trim())         e.title         = 'Required';
    if (!form.customerName.trim())  e.customerName  = 'Required';
    if (!form.customerEmail.trim()) e.customerEmail = 'Required';
    else if (!/\S+@\S+\.\S+/.test(form.customerEmail)) e.customerEmail = 'Invalid email';
    if (!form.content.trim())       e.content       = 'Required';
    return e;
  }

  async function submit(sendNow) {
    const e = validate(); setErrors(e);
    if (Object.keys(e).length) return;
    setLoading(true); setApiErr('');
    try {
      const result = existing
        ? await updateAgreement(existing.id, { ...form, send: sendNow })
        : await createAgreement({ ...form, send: sendNow });
      if (result.emailError) showToast(result.emailError, 'error');
      else showToast(sendNow ? `Agreement sent to ${form.customerEmail}` : 'Saved as draft.');
      onDone();
    } catch (err) { setApiErr(err.message); }
    finally { setLoading(false); }
  }

  const f = (key) => ({
    ...inp(errors[key]),
    onFocus: e => e.target.style.borderColor = errors[key] ? C.danger : C.brand,
    onBlur:  e => e.target.style.borderColor = errors[key] ? C.danger : C.border,
  });

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 28 }}>
        <Btn variant="ghost" onClick={onDone}>← Back</Btn>
        <div>
          <div style={{ fontSize: 22, fontWeight: 700, color: C.text }}>{existing ? 'Edit Agreement' : 'New Agreement'}</div>
          <div style={{ fontSize: 13, color: C.muted, marginTop: 2 }}>{existing ? `Editing: ${existing.title}` : 'Create and send a custom agreement to your customer'}</div>
        </div>
      </div>
      <Card>
        <ErrBox msg={apiErr} />
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20, marginBottom: 20 }}>
          <div>
            <label style={lbl}>Customer Name *</label>
            <input {...f('customerName')} value={form.customerName} onChange={e => setForm(p => ({ ...p, customerName: e.target.value }))} placeholder="Rahul Sharma" />
            {errors.customerName && <div style={{ color: C.danger, fontSize: 12, marginTop: 5 }}>{errors.customerName}</div>}
          </div>
          <div>
            <label style={lbl}>Customer Email *</label>
            <input {...f('customerEmail')} type="email" value={form.customerEmail} onChange={e => setForm(p => ({ ...p, customerEmail: e.target.value }))} placeholder="rahul@example.com" />
            {errors.customerEmail && <div style={{ color: C.danger, fontSize: 12, marginTop: 5 }}>{errors.customerEmail}</div>}
          </div>
        </div>
        <div style={{ marginBottom: 20 }}>
          <label style={lbl}>Agreement Title *</label>
          <input {...f('title')} value={form.title} onChange={e => setForm(p => ({ ...p, title: e.target.value }))} placeholder="e.g. Service Agreement – Q3 2026" />
          {errors.title && <div style={{ color: C.danger, fontSize: 12, marginTop: 5 }}>{errors.title}</div>}
        </div>
        <div style={{ marginBottom: 28 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
            <label style={{ ...lbl, marginBottom: 0 }}>Agreement Content *</label>
            <span style={{ fontSize: 11, color: C.muted }}>{form.content.length} chars</span>
          </div>
          <textarea
            style={{ ...inp(errors.content), minHeight: 220, resize: 'vertical', lineHeight: 1.75 }}
            onFocus={e => e.target.style.borderColor = errors.content ? C.danger : C.brand}
            onBlur={e => e.target.style.borderColor = errors.content ? C.danger : C.border}
            value={form.content}
            onChange={e => setForm(p => ({ ...p, content: e.target.value }))}
            placeholder="Write the full agreement text here. This will be shown to the customer for review and signature…"
          />
          {errors.content && <div style={{ color: C.danger, fontSize: 12, marginTop: 5 }}>{errors.content}</div>}
        </div>
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
          <Btn variant="primary" disabled={loading} onClick={() => submit(true)} style={{ boxShadow: `0 4px 16px ${C.brandGlow}` }}>
            📤 {loading ? 'Processing…' : existing ? 'Save & Resend' : 'Send to Customer'}
          </Btn>
          <Btn variant="ghost" disabled={loading} onClick={() => submit(false)}>💾 Save as Draft</Btn>
          <Btn variant="ghost" onClick={onDone} disabled={loading}>Cancel</Btn>
        </div>
      </Card>
    </div>
  );
}
